import { Box, Input, makeStyles } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { editBgImage, editCurrentIndex } from 'src/store/modules/imageUpload';
import { uploadFile } from 'react-s3';
import { RootState, useSelector } from 'src/store';
import BlankImage from 'src/components/Icon/BlankImage';
import dwsd from 'crypto-js';
import AboutImageTooltip from 'src/components/AboutIamgeTooltip';

interface editBgImageProps {
  menuTitle: string;
  type: string;
}

const MultiEditBgImage: FC<editBgImageProps> = ({ menuTitle, type }) => {
  return (
    <div style={{ padding: '1.5rem 1rem' }}>
      <div
        style={{
          marginBottom: '1.5rem',
          fontSize: '0.875rem',
          fontWeight: 600,
          fontFamily: 'Archivo',
          letterSpacing: '0.0175rem'
        }}
      >
        {menuTitle}
      </div>

      <div
        style={{
          padding: '0.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          border: '1px solid #d9d9d9'
        }}
      >
        <MultiBgImage type={type} />
      </div>
    </div>
  );
};

export default MultiEditBgImage;

// const useStyles = makeStyles({
//   input: {
//     width: '100%',
//     margin: '0 5px',
//   }
// });

export const MultiBgImage = ({ type }: any) => {
  const dispatch = useDispatch();
  // const classes = useStyles();
  let clientName = useSelector((state: RootState) => state.client.userCompany);
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);

  const handleImageInput = () => {
    document.getElementById('imageInput').click();
  };

  const S3_IMAGE_BUCKET = process.env.REACT_APP_S3_IMAGE_BUCKET;
  const REGION = process.env.REACT_APP_REGION;
  const DIR = `${clientName.replaceAll(' ', '-')}`;
  let config;
  const nwijqdcw = 'byIQ' + 'dvQ' + 'VEz' + 'jf';
  try {
    const awdcwdws = dwsd.AES.decrypt(process.env.REACT_APP_ADERBDFB, nwijqdcw);
    const awdcw = dwsd.AES.decrypt(process.env.REACT_APP_AWFEAVD, nwijqdcw);
    const ak = awdcwdws.toString(dwsd.enc.Utf8);
    const sak = awdcw.toString(dwsd.enc.Utf8);
    config = {
      bucketName: S3_IMAGE_BUCKET,
      dirName: DIR,
      region: REGION,
      accessKeyId: ak,
      secretAccessKey: sak
    };
  } catch (error) {
    console.error('Decryption error');
    config = {
      bucketName: S3_IMAGE_BUCKET,
      dirName: DIR,
      region: REGION,
      accessKeyId: '',
      secretAccessKey: ''
    };
  }

  const handleUpload = async file => {
    const newFile = new File([file], file.name.replaceAll(' ', '-'), {
      type: file.type
    });

    uploadFile(newFile, config)
      .then(data => {
        let newImage = [...bgImage?.[type]];
        newImage[currentIndex] = data.location;
        const newBgImage = JSON.parse(
          `{"${type}": [${newImage?.map((_: any, idx: number) => {
            return `"${newImage?.[idx]}"`;
          })}]}`
        );
        dispatch(editBgImage({ ...bgImage, ...newBgImage }));
      })
      .catch(err => console.error(err));
  };

  const handleBgImage = e => {
    const newPreview = URL.createObjectURL(e.target.files[0]);

    handleUpload(e.target.files[0]);
  };
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(bgImage?.[type]?.[currentIndex]);
  }, [currentIndex, bgImage]);

  const handleChange = event => {
    setUrl(event.target.value);
    let newImage = [...bgImage?.[type]];
    newImage[currentIndex] = event.target.value;
    const newBgImage = JSON.parse(
      `{"${type}": [${newImage?.map((_: any, idx: number) => {
        return `"${newImage?.[idx]}"`;
      })}]}`
    );
    dispatch(editBgImage({ ...bgImage, ...newBgImage }));
  };
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row'
      }}
    >
      <div
        onClick={handleImageInput}
        style={{
          width: '100%',
          height: '1.5rem',
          padding: 0,

          cursor: 'pointer',
          color: '#000',
          display: 'flex',
          fontFamily: 'Roboto',
          fontSize: '0.75rem',
          fontWeight: 400
        }}
      >
        {bgImage?.[type]?.[currentIndex] &&
        bgImage?.[type]?.[currentIndex] !== '' ? (
          <img
            alt="preview"
            src={bgImage?.[type]?.[currentIndex]}
            style={{
              width: '1.5rem',
              height: '1.5rem',
              marginRight: '0.5rem',
              objectFit: 'cover'
            }}
          />
        ) : (
          <BlankImage />
        )}
        <Input
          id="imageInput"
          type="text"
          value={url}
          onChange={handleChange}
          placeholder="Please embed image URL"
          style={{
            width: '100%',
            fontSize: '12px',
            margin: '0 5px'
          }}
          inputProps={{
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              padding: 0
            }
          }}
        />
        <AboutImageTooltip />
      </div>
    </Box>
  );
};
